export default __webpack_public_path__ + "static/21-dc220366c649999e551580819b2035e8.webp";